import { useEffect, useState } from "react";

import { toast, ToastContainer } from "react-toastify";
import { RTABAK_URLS } from "../../../utils/urls";
import "./AddManufacturingCost.scss";
import Label from "../../Label";
import Select, { SingleValue } from "react-select";
import ConfigSelect from "../AddProduct/ConfigSelect";
import CurrencyInput from "react-currency-input-field";
import request from "../../../services/request";

type Props = {
  setState: React.Dispatch<React.SetStateAction<any>>;
};
const AddManufacturingCost: React.FC<Props> = ({ setState }) => {
  const [checkedManufacturingCost, setCheckedManufacturingCost] =
    useState(false);
  const [displayValue, setDisplayValue] = useState<string>("0");
  const [manufacturingCost, setManufacturingCost] = useState<ManufacturingCost>(
    { title: "", value: 0, description: "", material: "" }
  );
  const handleChange = (e: any) => {
    setManufacturingCost({
      ...manufacturingCost,
      [e.currentTarget.name]: e.currentTarget.value,
    });
  };
  const handleChangeValue = (name: string, value: string) => {
    setDisplayValue(value);
    setManufacturingCost({
      ...manufacturingCost,
      [name]: value.replace(",", "."),
    });
  };

  const handleSelect = (
    selectedOption: SingleValue<{ value: string; label: string }>,
    e: any
  ) => {
    setManufacturingCost({
      ...manufacturingCost,
      [e.name]: selectedOption?.value,
    });
  };

  useEffect(() => {
    validateForm();
  }, [manufacturingCost]);

  const submitForm = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    addManufacturingCost();
  };

  const addManufacturingCost = () => {
    return request({
      baseURL: RTABAK_URLS.API.GetManufacturingCost,
      method: "POST",
      data: manufacturingCost,
    }).then((data) => {
      toast.success("Hechura guardada correctamente");
      setTimeout(() => {
        setState(true);
        resetForm();
        return data;
      }, 2000);
    });
  };

  const resetForm = () => {
    setDisplayValue("0");
    setManufacturingCost({
      title: "",
      value: 0,
      description: "",
      material: "",
    });
  };

  const validateForm = () => {
    manufacturingCost.description.length > 0 &&
    manufacturingCost.material.length > 0 &&
    manufacturingCost.title.length > 0 &&
    manufacturingCost.value >= 0
      ? setCheckedManufacturingCost(true)
      : setCheckedManufacturingCost(false);
  };
  return (
    <>
      <div className="addManufacturingCostContainer">
        <Label
          tag="h3"
          style={{
            textAlign: "left",
            fontFamily: "Mont-Semibold",
            marginBottom: "1.5rem",
          }}
        >
          Nueva hechura
        </Label>
        <form
          className="addManufacturingCost"
          onSubmit={submitForm}
          id="addManufacturingCostForm"
        >
          <div className="addManufacturingCost__input-container">
            <Label tag="label" className="addManufacturingCost__label">
              Título
            </Label>
            <input
              type="text"
              placeholder="Ej. Livianas"
              name="title"
              onChange={handleChange}
              value={manufacturingCost.title}
            ></input>
          </div>
          <div className="addManufacturingCost__input-container ">
            <Label tag="label" className="addManufacturingCost__label">
              Descripción
            </Label>
            <input
              type="text"
              placeholder="Ej. Hilo 0,20 a 0,60"
              name="description"
              onChange={handleChange}
              value={manufacturingCost.description}
            ></input>
          </div>
          <div className="addManufacturingCost__input-container">
            <Label tag="label" className="addManufacturingCost__label">
              Valor
            </Label>
            <div className="addManufacturingCost__price-input">
              <CurrencyInput
                id="input-value"
                name="value"
                placeholder="$"
                allowNegativeValue={false}
                defaultValue={0}
                decimalsLimit={2}
                value={displayValue}
                disableGroupSeparators={false}
                prefix="$ "
                groupSeparator="."
                decimalSeparator=","
                onValueChange={(name, value) =>
                  handleChangeValue(value ? value : "0", name ? name : "")
                }
              />
            </div>
          </div>
          <div className="addManufacturingCost__select-container">
            <ConfigSelect
              handleSelect={handleSelect}
              placeholder="Seleccionar..."
              value={{
                value: manufacturingCost.material,
                label:
                  manufacturingCost.material === ""
                    ? "Seleccionar..."
                    : manufacturingCost.material === "gold"
                    ? "Oro"
                    : "Plata",
              }}
              options={[
                { value: "gold", label: "Oro" },
                { label: "Plata", value: "silver" },
              ]}
              productConfig="material"
              label="Material"
            />
          </div>
        </form>
        {checkedManufacturingCost ? (
          <button
            type="button"
            onClick={submitForm}
            className="addManufacturingCost_button"
          >
            Agregar hechura
          </button>
        ) : (
          <button
            type="button"
            className="addManufacturingCost_button addManufacturingCost_button_disabled"
            disabled={true}
          >
            Agregar hechura
          </button>
        )}
      </div>
    </>
  );
};

export default AddManufacturingCost;
